module.exports = __webpack_public_path__ + "static/media/06_720.c3288b67.jpeg";